// set up togglers
const agendaTogglers = document.querySelectorAll('.agenda-toggler')

agendaTogglers.forEach((elem, idx) => {
  const expander = elem.parentElement.parentElement.querySelector('.expander')

  elem.addEventListener('click', (e) => {
    console.log('clicked')
    if (expander.clientHeight) {
      expander.style.height = 0
    } else {
      const wrapper = expander.querySelector('.measure-wrapper')
      expander.style.height = wrapper.clientHeight + 'px'
    }

    if (elem.innerHTML === 'Hide') {
      elem.innerHTML = 'Show'
    } else {
      elem.innerHTML = 'Hide'
    }
  })

  if (idx === 0) {
    const wrapper = expander.querySelector('.measure-wrapper')
    expander.style.height = wrapper.clientHeight + 'px'
    elem.innerHTML = 'Hide'
  }
})
